import { render, staticRenderFns } from "./OgStatusLabel.vue?vue&type=template&id=617d565e&scoped=true&"
import script from "./OgStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OgStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./OgStatusLabel.vue?vue&type=style&index=0&id=617d565e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d565e",
  null
  
)

export default component.exports